import { render, staticRenderFns } from "./groupon.vue?vue&type=template&id=6d6efc54&scoped=true&"
import script from "./groupon.vue?vue&type=script&lang=js&"
export * from "./groupon.vue?vue&type=script&lang=js&"
import style0 from "./groupon.vue?vue&type=style&index=0&id=6d6efc54&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6efc54",
  null
  
)

export default component.exports